import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import menu from './menu'
import { storage } from '@/utils/storage'
import layout from "@/layout/layout.vue";
import axios from 'axios';

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        name: 'Root',
        component: layout,
        redirect: '/loan/apply',
        children: menu
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/login.vue')
    },
    {
        path: '/detail',
        name: 'detail',
        component: layout,
        children: [
            {
                path: '/loan/applyDetail/:id',
                name: 'applyDetail',
                component: () => import('@/views/loan/applyDetail.vue'),
                meta: {
                    label: '贷款申请详情',
                    hideSideBar: true
                }
            },
            {
                path: '/loan/in/:id/:applyId',
                name: 'inDetail',
                component: () => import('@/views/loan/inDetail.vue'),
                meta: {
                    label: '贷中详情',
                    hideSideBar: true
                }
            },
            {
                path: '/customer/detail/:id',
                name: 'customerDetail',
                component: () => import('@/views/customer/detail.vue'),
                meta: {
                    label: '客户详情',
                    hideSideBar: true
                }
            },
            {
                path: '/shop/detail/:sellerId/:userId?',
                name: 'shopDetail',
                component: () => import('@/views/shop/detail.vue'),
                meta: {
                    label: '店铺详情',
                    hideSideBar: true
                }
            },
            {
                path: '/report/detail/:id',
                name: 'reportDetail',
                component: () => import('@/views/report/riskReport.vue'),
                meta: {
                    label: '报告详情',
                    hideSideBar: true
                }
            }
        ]
    }
]
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    // 始终滚动到顶部
    return { top: 0 }
  },
  routes
})



router.beforeEach((to, from, next) => {
    const oldV = localStorage.getItem('version')
    const timestamp = Date.now()
    const version = async () => {
        try {
            const response = await axios.get(`/version.json?timestamp=${timestamp}`)
            const newV = response.data?.version
            if (!newV) return
            if (oldV && oldV !== newV) {
                localStorage.setItem('version', newV)
                window.location.reload()
            } else if (!oldV) {
                localStorage.setItem('version', newV)
            }
        } catch (error) {
            // 版本文件异常时不触发刷新，避免形成无限刷新循环。
            console.warn('读取版本信息失败', error)
        }
    }
    version()
  if (to.name !== 'login' && !storage.get(process.env.VUE_APP_COOKIE_KEY)) next({ name: 'login' })
  else next()
})

export default router
